import { object, string, boolean } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'
import type { Ticket } from 'components/tickets/types'

export const Schema = object().shape({
  visitId: string().required(),
  showPhase4Tickets: boolean().optional().default(undefined),
})

export type Request = {
  visitId: string
  showPhase4Tickets?: boolean
}

export const url = ({ visitId, showPhase4Tickets }: Request) => {
  const baseUrl = `/v1/tickets/visits/${visitId}`

  const params = new URLSearchParams()

  if (showPhase4Tickets !== undefined) {
    params.append('show_phase4_tickets', showPhase4Tickets.toString())
  }

  const queryString = params.toString()
  const finalUrl = queryString ? `${baseUrl}?${queryString}` : baseUrl

  return finalUrl
}

export type SuccessfulResponse = Ticket[]
